import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { ensureElvaFontsReady, initPersistedTheme } from '@elva/ui';
import { AppProviders } from '@/app/providers';
import { router } from '@/app/router';
import '@/styles/global.css';

initPersistedTheme('neue', 'elva-theme-frontdesk');

class RootErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { error: Error | null }
> {
  override state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  override render() {
    if (this.state.error) {
      return (
        <div
          style={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 24,
            fontFamily: 'system-ui, sans-serif',
            background: '#f5f5f7',
            color: '#1d1d1f',
          }}
        >
          <div style={{ maxWidth: 560 }}>
            <h1 style={{ fontSize: 20, marginBottom: 8 }}>FrontDesk failed to start</h1>
            <pre
              style={{
                whiteSpace: 'pre-wrap',
                fontSize: 13,
                background: '#fff',
                border: '1px solid #e7e7ec',
                borderRadius: 8,
                padding: 16,
              }}
            >
              {this.state.error.message}
            </pre>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

async function bootstrap() {
  const rootElement = document.getElementById('root');
  if (!rootElement) throw new Error('Root element #root not found');

  await ensureElvaFontsReady();

  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <RootErrorBoundary>
        <AppProviders>
          <RouterProvider router={router} />
        </AppProviders>
      </RootErrorBoundary>
    </React.StrictMode>,
  );
}

void bootstrap();
